
export const SIZE_FULL = 'full';
export const SIZE_HALF = 'half';
export const SIZE_THREE_QUARTERS = 'three_quarters';

export const BUTTON_HOME = 'home';
export const BUTTON_SAVE_ACCOUNT = 'saveAccount';
